import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { constructIds, getConstructType } from '../../../config/common'
import RoutingRuleForm from "./RoutingRuleForm";
import { invokePostService, invokeGetService, handleSnackBar } from "../../../store/global/actions";
import { findDelegateLinkedNodes, generateRRDefName } from "../../../services/entities/routing_rules";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js"
import { getEventParentTransaction } from "../../../services/entities/event.js";

export default function CreateRoutingRule(props) {

    const { onCompletion, onClose, element } = props;
    const dispatch = useDispatch();
    const [allEvents, setEvents] = useState([]);
    const [rrdefs, setRrdefs] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [defaultObj, setDefaultObj] = useState({ tag: null, tcmd: "", ttype: "", dir: "" });
    const [selectedDelegate, setSelectedDelegate] = useState(null);
    const [clusterlets, setClusterlets] = useState([]);
    const [dirOut, setDirOut] = useState(null);
    const [delegateConnectedNodes, setDelegateConnectedNodes] = useState([]);
    const [rrdefSchema, setRrdefSchema] = useState([]);
    const [autoRrdefName, setAutoRrdefName] = useState(null);
    useEffect(() => {
        setIsFetching(true);
        Promise.all([dispatch(invokeGetService('getBlueprintConstructs', [])),
        dispatch(invokeGetService('getRrdefPlatformSchema', [element.protocol]))])
            .then(([response, routingRuleSchema]) => {
                if (response.data !== undefined) {
                    setEvents(response.data.events)
                    setRrdefs(response.data.rrdefs)
                    setClusterlets(response.data.clusterlets);
                    if (element.type == constructIds.find(item => item.type === "events").id) {
                        const tag = "event";
                        const event = response.data.events.find(item => item._id == element.id)
                        const src = response.data.clusterlets.find(item => item._id == event.src)
                        const dst = response.data.clusterlets.find(item => item._id == event.dst)
                        const ttype = getConstructType(src.type) !== 'external_function' ? src._id : dst._id;
                        const dir = getConstructType(src.type) !== 'external_function' ? 'OUT' : 'IN';
                        const tcmd = event._id;

                        setDefaultObj({ tag: tag, ttype: ttype, dir: dir, tcmd: tcmd })

                        const clusterlet = response.data.clusterlets.find(item => item._id == ttype);
                        setDelegateConnectedNodes([{ label: clusterlet.name, value: clusterlet._id }])

                        if (dir === 'IN') setDirOut(false);
                        else setDirOut(true)

                        const delegateId = getConstructType(src.type) == 'external_function' ? src._id : dst._id;
                        const delegate = response.data.clusterlets.find(item => item._id == delegateId);
                        setSelectedDelegate(delegate);

                        const selectedTransaction = getEventParentTransaction({transactions: response.data.transactions, eventId: element.id});
                        if (selectedTransaction && event) {
                            const generatedName = generateRRDefName(selectedTransaction.name, event.name);
                            setAutoRrdefName(generatedName);
                        }
                    } else {
                        const delegate = response.data.clusterlets.find(item => item._id == element.id);
                        setSelectedDelegate(delegate);
                        setDelegateConnectedNodes(findDelegateLinkedNodes({ id: element.id, clusterlets: response.data.clusterlets, events: response.data.events }))
                    }
                }
                if (routingRuleSchema.status) {
                  setRrdefSchema(routingRuleSchema.data);
                }
                setIsFetching(false);
            })
    }, [])




    const onSave = async (data) => {
        try {
            const response = await dispatch(invokePostService('createRrdef', { rrdefData: data }, []));
            if (response.status == true) {
                onCompletion('Routing rule', 'add');
            } else if (response.status == false && response.errors == undefined && response.message) {
                dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
            }
            return response;
        } catch (error) {
            console.log(error)
            dispatch(handleSnackBar({ open: true, message: 'Something went wrong', severity: "error" }));
            return { status: false, message: 'Something went wrong' };
        }
    }

   
    return (
        <>  
            {isFetching && <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '35vh' }} />}
            {!isFetching && rrdefSchema.length > 0 &&
                <RoutingRuleForm
                    allEvents={allEvents}
                    rrdefs={rrdefs}
                    defaultObj={defaultObj}
                    selectedDelegate={selectedDelegate}
                    clusterlets={clusterlets}
                    onSave={onSave}
                    onClose={onClose}
                    rrdefSchema={rrdefSchema}
                    loading={isFetching}
                    autoRrdefName={autoRrdefName}
                    action="create"
                />}
        </>
    );
}

